import { Trans, useTranslation } from 'react-i18next';

import { Undo } from '@/components/common/svg/Undo.tsx';
import { FileData } from '@/shared/interface/userRegistrationData.ts';
import {
  buttonContainerStyles,
  contentStyles,
  imageStyles
} from '@/components/ProfileData/Selfie/styles.ts';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import {
  cardStyle,
  iconWrapperStyle,
  mainTextStyle,
  optionStyle,
  subTextStyle,
  textContainerStyle
} from '@/components/Registration/UserPhotos.tsx';
import { Image } from '@/components/common/Image/Image.tsx';
import ShieldShape from '@/components/common/svg/shapes/ShieldShape.tsx';
import { PhotoKind } from '@/shared/type/userDataFields.ts';
import UserCheckShape from '@/components/common/svg/shapes/UserCheckShape.tsx';
import { Smile } from '@/components/common/svg/Smile.tsx';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';

interface PhotoStateProps {
  takenSelfie: FileData | null;
  handleRetake: () => void;
  isSubmitting?: boolean;
}

export const ShowTakenSelfie = ({
  takenSelfie,
  handleRetake,
  isSubmitting
}: PhotoStateProps) => {
  const { t } = useTranslation();

  const handleRetakeClick = () => {
    if (isSubmitting) return;
    handleRetake();
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Image
        src={takenSelfie?.url[PhotoKind.KIND_PRIMARY]}
        style={imageStyles}
        alt="selfie"
      />
      <div
        style={{
          ...buttonContainerStyles,
          opacity: isSubmitting ? 0.5 : 1,
          pointerEvents: isSubmitting ? 'none' : 'auto'
        }}
        onClick={handleRetakeClick}
      >
        <span style={contentStyles}>
          <Undo />
          {t('selfie.retake')}
        </span>
      </div>
    </div>
  );
};

export const SelfieRequirementsSections = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          margin: '100px 0 100px -10px'
        }}
      >
        <VerifiedBadgeShape width={50} height={50} />
        <div style={{ ...textContainerStyle, flexGrow: 0 }}>
          <span style={{ ...mainTextStyle, fontSize: '24px' }}>
            {t('registration.verify_yourself')}
          </span>
          <span style={{ ...subTextStyle, fontSize: '14px' }}>
            <Trans
              i18nKey="registration.verify_yourself_sub"
              components={{
                br: <br />
              }}
            />
          </span>
        </div>
      </div>
      <InputContent style={{ marginTop: 20 }}>
        <div style={cardStyle}>
          <div style={optionStyle}>
            <div style={iconWrapperStyle}>
              <Smile height={25} width={25} />
            </div>
            <div style={textContainerStyle}>
              <span style={mainTextStyle}>{t('selfie.verify_yourself')}</span>
              <span style={subTextStyle}>
                {t('selfie.verify_yourself_subtitle')}
              </span>
            </div>
          </div>
          <div style={optionStyle}>
            <div style={iconWrapperStyle}>
              <UserCheckShape height={25} width={25} />
            </div>
            <div style={textContainerStyle}>
              <span style={mainTextStyle}>
                {t('selfie.only_real_profiles')}
              </span>
              <span style={subTextStyle}>
                {t('selfie.only_real_profiles_subtitle')}
              </span>
            </div>
          </div>
          <div style={{ ...optionStyle, borderBottom: 'none' }}>
            <div style={iconWrapperStyle}>
              <ShieldShape height={25} width={23} />
            </div>
            <div style={textContainerStyle}>
              <span style={mainTextStyle}>{t('selfie.privacy')}</span>
              <span style={subTextStyle}>{t('selfie.privacy_subtitle')}</span>
            </div>
          </div>
        </div>
      </InputContent>
    </>
  );
};
